import { MapSelectionRequest } from "../map/map-selection.interface";

/**
 * Enumeration for different image search methods
 */
export enum ImageSearchMethod {
  URL = "url",
  UPLOAD = "upload",
  WKT = "wkt",
}

/**
 * Configuration interface for image search dialog
 */
export interface ImageSearchDialogConfig {
  /** URL of the image if pre-loaded */
  url?: string;
  /** Base64 data if image is pre-loaded */
  base64Data?: string;
  /** WKT geometry if area is pre-selected */
  wkt?: string;
  /** Preloaded URL for wkt */
  previewUrl?: string;
  /** Maximum file size in bytes */
  maxFileSize?: number;
  /** Supported file formats */
  supportedFormats?: string[];
  /** Allowed file types */
  allowedFileTypes?: string[];
  /** Dialog title */
  title?: string;
  /** Dialog description */
  description?: string;
  /** Initial search method */
  initialMethod?: ImageSearchMethod;
  /** Preloaded URL */
  preloadedUrl?: string;
  /** Whether map area selection is enabled (based on display mode) */
  canUseMapSelection?: boolean;
}

/**
 * Result returned by image search dialog
 * As clarified, this always returns either URL or base64 data
 */
export interface ImageSearchDialogResult {
  /** Whether the search was successful */
  success: boolean;
  /** Search method used */
  searchMethod: ImageSearchMethod;
  /** Map selection request if area selection is needed */
  mapSelectionRequest?: MapSelectionRequest;
  /** URL for search-url action */
  url?: string;
  /** Base64 data for search-data action */
  base64Data?: string;
  /** Data URL preview of the image (with data:image/ prefix) for display purposes */
  imagePreview?: string;
}
